// extracted by mini-css-extract-plugin
export default {"saleprice":"SaleItemsMoby_saleprice__numcS","fakprice":"SaleItemsMoby_fakprice__Frinp"};